import PlateContainer from "./container";

export default PlateContainer;
